// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Iipk","fullView":"styles_fullView__1Utve"};